// "use client";
// import React from "react";
// import { Box, Container, Typography } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { useTranslation } from "react-i18next";

// // ─── Assets ─────────────────────────────────────────────────────────────────
// const BG_IMG = "https://getgeek-website-assets.b-cdn.net/AI2026BGImg.webp";

// // ─── Styled Components ──────────────────────────────────────────────────────
// const AI2026Section = styled(Box)(({ theme }) => ({
//   position: "relative",
//   backgroundColor: "#0B0715",
//   paddingTop: "56px",
//   paddingBottom: "290px",
//   overflow: "hidden",
//   [theme.breakpoints.down("sm")]: {
//     paddingTop: "40px",
//     paddingBottom: "20px",
//     backgroundColor: "#171520",
//   },
// }));

// const BgImage = styled("img")(({ theme }) => ({
//   position: "absolute",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   objectFit: "cover",
//   objectPosition: "top center",
//   zIndex: 0,
//   pointerEvents: "none",
//   [theme.breakpoints.down("sm")]: {
//     display: "none",
//   },
// }));

// const ContentWrapper = styled(Box)({
//   position: "relative",
//   zIndex: 1,
// });

// const TextWrapper = styled(Box, {
//   shouldForwardProp: (prop) => prop !== "isRTL",
// })(({ theme, isRTL }) => ({
//   textAlign: "center",
//   maxWidth: "780px",
//   margin: "0 auto",
//   [theme.breakpoints.down("sm")]: {
//     textAlign: isRTL ? "right" : "left",
//     margin: 0,
//   },
// }));

// const Eyebrow = styled(Typography, {
//   shouldForwardProp: (prop) => prop !== "isRTL",
// })(({ theme, isRTL }) => ({
//   display: "inline-flex",
//   alignItems: "center",
//   gap: "8px",
//   fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
//   fontSize: "16px",
//   fontWeight: 700,
//   letterSpacing: "1px",
//   textTransform: "uppercase",
//   color: "#9048FB",
//   marginBottom: "20px",
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "12px",
//   },
//   "&::before": {
//     content: '""',
//     display: "inline-block",
//     width: "6px",
//     height: "6px",
//     borderRadius: "50%",
//     backgroundColor: "#A78BFA",
//   },
// }));

// const SectionHeading = styled(Typography, {
//   shouldForwardProp: (prop) => prop !== "isRTL",
// })(({ theme, isRTL }) => ({
//   fontFamily: isRTL ? "var(--font-plusjakarta)" : "var(--font-plusjakarta)",
//   fontWeight: 700,
//   fontSize: "35px",
//   lineHeight: 1.35,
//   color: "#FFFFFF",
//   marginBottom: "24px",
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "25px",
//   },
// }));

// const SectionParagraph = styled(Typography, {
//   shouldForwardProp: (prop) => prop !== "isRTL",
// })(({ isRTL }) => ({
//   fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
//   fontSize: "16px",
//   lineHeight: 1.9,
//   color: "#B8B4C4",
//   marginBottom: "16px",
// }));
// const SectionParagraphTwo = styled(Typography, {
//   shouldForwardProp: (prop) => prop !== "isRTL",
// })(({ isRTL }) => ({
//   fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
//   fontSize: "16px",
//   lineHeight: 1.9,
//   color: "#B8B4C4",
// }));

// // ─── Component ───────────────────────────────────────────────────────────────
// const LeapAI2026Section = () => {
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.language === "ar";

//   return (
//     <AI2026Section>
//       <BgImage src={BG_IMG} alt="" />
//       <ContentWrapper>
//         <Container maxWidth="lg">
//           <TextWrapper isRTL={isRTL}>
//             <Eyebrow isRTL={isRTL}>{t("leapAI2026Section.eyebrow")}</Eyebrow>

//             <SectionHeading variant="h2" isRTL={isRTL}>
//               {t("leapAI2026Section.heading")}
//             </SectionHeading>

//             <SectionParagraph isRTL={isRTL}>
//               {t("leapAI2026Section.paragraphOne")}
//             </SectionParagraph>

//             <SectionParagraphTwo isRTL={isRTL}>
//               {t("leapAI2026Section.paragraphTwo")}
//             </SectionParagraphTwo>
//           </TextWrapper>
//         </Container>
//       </ContentWrapper>
//     </AI2026Section>
//   );
// };

// export default LeapAI2026Section;


"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// ─── Assets ─────────────────────────────────────────────────────────────────
const BG_IMG = "https://getgeek-website-assets.b-cdn.net/AI2026BGImg.webp";
const MOBILE_IMG =
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI-2026.webp";

// ─── Styled Components ──────────────────────────────────────────────────────
const AI2026Section = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#0B0715",
  paddingTop: "56px",
  paddingBottom: "290px",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    paddingTop: "40px",
    paddingBottom: "20px",
    backgroundColor: "#171520",
  },
}));

const BgImage = styled("img")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "top center",
  zIndex: 0,
  pointerEvents: "none",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const ContentWrapper = styled(Box)({
  position: "relative",
  zIndex: 1,
});

const TextWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isRTL",
})(({ theme, isRTL }) => ({
  textAlign: "center",
  maxWidth: "780px",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    textAlign: isRTL ? "right" : "left",
    margin: 0,
  },
}));

const Eyebrow = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isRTL",
})(({ theme, isRTL }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
  fontSize: "16px",
  fontWeight: 700,
  letterSpacing: "1px",
  textTransform: "uppercase",
  color: "#9048FB",
  marginBottom: "20px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
  "&::before": {
    content: '""',
    display: "inline-block",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#A78BFA",
  },
}));

const SectionHeading = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isRTL",
})(({ theme, isRTL }) => ({
  fontFamily: isRTL ? "var(--font-plusjakarta)" : "var(--font-plusjakarta)",
  fontWeight: 700,
  fontSize: "35px",
  lineHeight: 1.35,
  color: "#FFFFFF",
  marginBottom: "24px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "25px",
  },
}));

const SectionParagraph = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isRTL",
})(({ isRTL }) => ({
  fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
  fontSize: "16px",
  lineHeight: 1.9,
  color: "#B8B4C4",
  marginBottom: "16px",
}));
const SectionParagraphTwo = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isRTL",
})(({ isRTL }) => ({
  fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
  fontSize: "16px",
  lineHeight: 1.9,
  color: "#B8B4C4",
}));

// Mobile-only image shown below the text content on small screens
const MobileImage = styled("img")(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "block",
    width: "100%",
    height: "auto",
    marginTop: "24px",
    borderRadius: "12px",
  },
}));

// ─── Component ───────────────────────────────────────────────────────────────
const LeapAI2026Section = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <AI2026Section>
      <BgImage src={BG_IMG} alt="" />
      <ContentWrapper>
        <Container maxWidth="lg">
          <TextWrapper isRTL={isRTL}>
            <Eyebrow isRTL={isRTL}>{t("leapAI2026Section.eyebrow")}</Eyebrow>

            <SectionHeading variant="h2" isRTL={isRTL}>
              {t("leapAI2026Section.heading")}
            </SectionHeading>

            <SectionParagraph isRTL={isRTL}>
              {t("leapAI2026Section.paragraphOne")}
            </SectionParagraph>

            <SectionParagraphTwo isRTL={isRTL}>
              {t("leapAI2026Section.paragraphTwo")}
            </SectionParagraphTwo>

            <MobileImage src={MOBILE_IMG} alt="" />
          </TextWrapper>
        </Container>
      </ContentWrapper>
    </AI2026Section>
  );
};

export default LeapAI2026Section;